// Chakra imports
import {
  Alert,
  Button,
  Flex,
  Spinner,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
import { apiurl } from "APIURL";
import axios from "axios";
import Card from "components/card/Card";
// Custom components
import SwitchField from "components/fields/SwitchField";
import Menu from "components/menu/MainMenu";
import { useEffect, useState } from "react";
import { useAppSelector } from "redux/hooks";
import { getProfileData } from "redux/slices/userSlice";
import { NotificationPreference, Preference } from "types";

const mapUserPrefs = (pref: keyof Preference) => {
  switch (pref) {
    case "FORMATION_CREATE":
      return "Nouveaux formations";
    case "FORMATION_UPDATE":
      return "Mises à jour des formations";
    case "FORMATION_DELETE":
      return "Suppression des formations";
    case "COURSE_CREATE":
      return "Nouveaux cours";
    case "COURSE_UPDATE":
      return "Mises à jour des cours";
    case "COURSE_DELETE":
      return "Suppression des cours";
    case "TEST_UPDATE":
      return "Mises à jour des tests";
    default:
      return "Mises à jour de profil";
  }
};

export default function Notifications(props: { [x: string]: any }) {
  const { ...rest } = props;
  // Chakra Color Mode
  const [userPrefs, setUserPrefs] = useState<NotificationPreference[]>([]);
  const [allPrefs, setAllPrefs] = useState<NotificationPreference[]>([]);
  const [loadingUserPrefs, setLoadingUserPrefs] = useState(false);
  const [loadingAllPrefs, setLoadingAllPrefs] = useState(false);
  
  
  const [loadingRequest, setLoadingRequest] = useState(false);

  const user = useAppSelector(getProfileData);
  const [error, setError] = useState(null);

  const getIsCheckedPreference = (pref: NotificationPreference) => {
    return userPrefs.some((item) => item.id === pref.id);
  };

  const activatePreferences = (prefs: NotificationPreference) => {
    setUserPrefs((prevUserPrefs) => [...prevUserPrefs, prefs]);
    console.log(userPrefs)
  };
  const updateHandler = async () => {
    try {
      setLoadingRequest(true)
      const res = await axios.patch(
        `${apiurl}/user/updateUserPrefs/${user.userId}`,
        userPrefs.map(item=>{
          return {
            id:item.id
          }
        })
      );
      setUserPrefs(res.data);
      setLoadingRequest(false)
      console.log(res.data);
    } catch (err) {
      console.log(err);
      setLoadingRequest(false)
    }
  }
  console.log({ userPrefs });

  useEffect(() => {
    const getUserPrefs = async (id: string) => {
      console.log("loading...");
      try {
        setLoadingUserPrefs(true);
        const res = await axios.get(`${apiurl}/user/userPrefs/${id}`);
        console.log(res.data);
        setUserPrefs(res.data);
        setLoadingUserPrefs(false);
        console.log({ userPrefs });
      } catch (err) {
        setError(<Alert>Erreur d'obtention des données</Alert>);
        setLoadingUserPrefs(false);
      }
    };

    getUserPrefs(localStorage.getItem("userId"));
  }, []);

  useEffect(() => {
    const getAllPrefs = async () => {
      try {
        setLoadingAllPrefs(true);
        const res = await axios.get(`${apiurl}/user/allPrefs`);
        setAllPrefs(res.data);
        setLoadingAllPrefs(false);
      } catch (err) {
        setError(<Alert>Erreur d'obtention des données</Alert>);
        setLoadingAllPrefs(false);
      }
    };

    getAllPrefs();
  }, []);

  const textColorPrimary = useColorModeValue("secondaryGray.900", "white");

  return (
    <Card mb="20px" {...rest}>
      <Flex align="center" w="100%" justify="space-between" mb="30px">
        <Text
          color={textColorPrimary}
          fontWeight="bold"
          fontSize="2xl"
          mb="4px"
        >
          Notifications
        </Text>
        <Menu />
      </Flex>
        {loadingAllPrefs === true ? (
        <Spinner />
      ) : (
        <>
          {allPrefs.map((item) => 
            
            {
            return <SwitchField
              key={item.id}
              isChecked={getIsCheckedPreference(item)}
              onChange={() => activatePreferences(item)}
              reversed={true}
              fontSize="sm"
              mb="20px"
              id={item.id.toString()}
              label={mapUserPrefs(item.preference)}
            />}
          )}
        </>
      )}
      <Button w={"20%"} colorScheme={"brandScheme"} onClick={e=>updateHandler()}>{loadingRequest===true?<Spinner color="gray.50" />:"Valider les modifications"}</Button>
    
    </Card>
  );
}
